<template>
  <div class="PresentPersonelListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "PerNo",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("SectionName"),
          value: "Section",
        },
        {
          text: this.$t("WorkGroup"),
          value: "WorkGroup",
        },
        
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>